import React, { FC } from 'react';
import { useHistory } from 'react-router';

import { Modal } from 'app/design-system/components/Modal';
import { useTranslation } from 'app/lang';
import { QRCode } from 'app/widgets/QRCode';

import dictionary from './DownloadModal.dictionary.json';

import styles from './DownloadModal.module.scss';

type DownloadModalProps = {
  host: string;
};

const FROM_PARAM_KEY = 'from';
const MODAL_PARAM_KEY = 'download';

export const getModalLink = (from: string) => {
  if (from) {
    return `?${MODAL_PARAM_KEY}&${FROM_PARAM_KEY}=${from}`;
  }

  return `?${MODAL_PARAM_KEY}`;
};

export const DownloadModal: FC<DownloadModalProps> = ({ host }) => {
  const { location, replace } = useHistory();
  const { t } = useTranslation();

  const urlParams = new URLSearchParams(location.search);
  const isOpen = urlParams.has(MODAL_PARAM_KEY);
  const from = urlParams.get(FROM_PARAM_KEY);

  const onClose = () => replace({ search: '' });

  return (
    <Modal isOpen={isOpen}
           onClose={onClose}
           maxWidth={536}>
      <Modal.Header>
        {t(dictionary.title)}
      </Modal.Header>
      <Modal.Body className={styles.content}>
        <QRCode className={styles.code}
                size={488}
                value={host}
                searchParams={{ from }} />
      </Modal.Body>
    </Modal>
  );
};
